import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

import type { AccountDrawerProps } from './components/account-drawer';

// ----------------------------------------------------------------------

export const _account: AccountDrawerProps['data'] = [
  { label: 'Home', href: '/', icon: <Iconify icon="solar:home-angle-bold-duotone" /> },
  {
    label: 'Profilo',
    href: '/account',
    icon: <Iconify icon="custom:profile-duotone" />,
  }
];

// Area impostazioni NON in primo piano: la gestione d'emergenza della piattaforma consulenti sta solo qui,
// e solo per Amministratore e Backoffice.
export const getAccountData = (role?: string): AccountDrawerProps['data'] =>
  role === 'Amministratore' || role === 'Backoffice'
    ? [
        ..._account!,
        {
          label: 'Emergenza piattaforma',
          href: paths.dashboard.emergenza.root,
          icon: <Iconify icon="solar:shield-keyhole-bold-duotone" />,
        },
      ]
    : _account;
